import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr";
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  constructor(public router: Router) { }
  public data: any = [];
 
  private hubConnection: signalR.HubConnection;
  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.apiUrl +'/user')
                            .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => {
        console.log('Error while starting connection: ' + err);
        setTimeout(this.startConnection, 5000);
      });
  }
 
  public addTransferUserDataListener = () => {
    this.hubConnection.on('transferuserdata', (data) => {
      this.data = data;
      if (! data.active) {
        this.router.navigate(['/login']);
      }
    });
  }
}
